import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { FormWrapper } from '~/features/Registration/styled'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, PickPhotos } from '~/shared/ui/form'
import { uploadPhoto } from './helpers'
import { formSchema, FormValues } from './model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onSuccess, isSubmitting }: FormProps) {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <FormWrapper>
        <PickPhotos
          descriptions='Добавьте две фотографии: первого разворота паспорта и прописки'
          name='passportPhotos'
          fnUpload={(file: Blob) => uploadPhoto(file)}
          multiple
          maxPhotos={2}
          title='Паспорт'
        />

        <PickPhotos
          descriptions='Добавьте две фотографии водительского удостоверения: с лицевой и с обратной стороны'
          name='drivingLicensePhotos'
          multiple
          fnUpload={(file: Blob) => uploadPhoto(file)}
          maxPhotos={2}
          title='Водительское удостоверение'
        />

        <br />
        <Button
          loading={isSubmitting}
          variant='limeFlooded'
          size='large'
          type='submit'
          fullWidth
        >
          Отправить документы
        </Button>
      </FormWrapper>
    </FormProvider>
  )
}
